import React from "react";
import {motion} from "framer-motion"
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2010 - 2022</p>
          <h2 className="text-3xl md:text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Freelance Digital Marketing Expert"
            subTitle="Self Employed - (2017 - Present)"
          
            des="To Handle Multiple Client's Requirements about the Socila Media service like SEO,SMO,Google Ads run etc."
          />
          <ResumeCard
            title="Freelance Web Developer & Trainer"
            subTitle="Self Employed- (2012 - 2016)"
            
            des="To Handle Multiple Client's Requirements about the Developement and designing."
          />
          <ResumeCard
            title="Freelance Graphics Designer"
            subTitle="Self Employed - (2020 - 2011)"
            
            des="To Handle Multiple Client's Requirements about the videos editing and motion graphics."
          />
        </div>
      </div>
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2001 - 2020</p>
          <h2 className="text-3xl md:text-4xl font-bold">Trainer Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Marketing Instructor"
            subTitle="Rainbow Gym Center (2015 - 2020)"
            result="USA"
            des="Trained The Gym Marketing of their portfolio."
          />
          <ResumeCard
            title="Web Developer and Instructor"
            subTitle="Fussion Associate(2010 - 2014)"
            result="CANADA"
            des="To design and develope of the company in a structure manner."
          />
          <ResumeCard
            title="Graphics Designer"
            subTitle="Avg Digital (2001 - 2010)"
            result="NEVADA"
            des="To animate the whole 3d modeling and editing of their whole products."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Experience;
